export const categories = [
  { slug: 'rexue', name: '热血', icon: 'ri-fire-line', color: 'primary' },
  { slug: 'lianai', name: '恋爱', icon: 'ri-heart-line', color: 'primary' },
  { slug: 'qihuan', name: '奇幻', icon: 'ri-magic-line', color: 'accent' },
  { slug: 'gaoxiao', name: '搞笑', icon: 'ri-emotion-laugh-line', color: 'accent' },
  { slug: 'zhanji', name: '战斗', icon: 'ri-sword-line', color: 'secondary' },
  { slug: 'xuanyi', name: '悬疑', icon: 'ri-search-eye-line', color: 'secondary' },
  { slug: 'richang', name: '日常', icon: 'ri-sun-line', color: 'primary' },
  { slug: 'kehuan', name: '科幻', icon: 'ri-rocket-line', color: 'accent' },
  { slug: 'maoxian', name: '冒险', icon: 'ri-compass-3-line', color: 'secondary' },
  { slug: 'xiaoyuan', name: '校园', icon: 'ri-building-2-line', color: 'primary' },
];

export const regions = [
  { slug: 'riben', name: '日本动漫' },
  { slug: 'guoman', name: '国漫' },
  { slug: 'oumei', name: '欧美动漫' },
];

export const years = [
  { slug: '2026', name: '2026年' },
  { slug: '2025', name: '2025年' },
  { slug: '2024', name: '2024年' },
  { slug: '2023', name: '2023年' },
  { slug: 'zaonian', name: '早年经典' },
];

export const trendingAnime = [
  {
    id: 1,
    title: '咒术回战 第三季',
    titleJa: '呪術廻戦 第3期',
    category: 'rexue',
    region: 'riben',
    year: '2026',
    rating: 9.7,
    episode: '更新至第8话',
    description: '虎杖悠仁与伙伴们迎来更加激烈的战斗，宿傩的威胁日益逼近，咒术高专全体出动迎战史上最强诅咒。',
    coverUrl: 'https://readdy.ai/api/search-image?query=Jujutsu%20Kaisen%20season%203%20anime%20promo%20art%2C%20dark%20atmosphere%20with%20action%20pose%2C%20stylish%20Japanese%20animation%20style%2C%20dramatic%20lighting%2C%20warm%20tone%20accents%20on%20dark%20background%2C%20clean%20composition%2C%20cinematic%20illustration%20quality&width=600&height=800&seq=trending-anime-01&orientation=portrait',
    tags: ['热血', '战斗', '超人气'],
  },
  {
    id: 2,
    title: '葬送的芙莉莲 第二季',
    titleJa: '葬送のフリーレン 第2期',
    category: 'qihuan',
    region: 'riben',
    year: '2026',
    rating: 9.8,
    episode: '更新至第5话',
    description: '芙莉莲继续她的旅程，在新的冒险中探寻魔法的真谛，与伙伴们的羁绊也愈发深厚。',
    coverUrl: 'https://readdy.ai/api/search-image?query=Frieren%20anime%20season%202%20promotional%20art%2C%20fantasy%20landscape%20with%20elf%20character%2C%20soft%20warm%20lighting%2C%20peaceful%20atmosphere%2C%20beautiful%20natural%20scenery%2C%20anime%20illustration%20with%20gentle%20color%20palette&width=600&height=800&seq=trending-anime-02&orientation=portrait',
    tags: ['奇幻', '冒险', '催泪'],
  },
  {
    id: 3,
    title: '鬼灭之刃 无限城篇',
    titleJa: '鬼滅の刃 無限城編',
    category: 'rexue',
    region: 'riben',
    year: '2026',
    rating: 9.9,
    episode: '更新至第3话',
    description: '炭治郎与鬼杀队深入无限城，迎来与鬼舞辻无惨的最终决战，命运的齿轮开始转动。',
    coverUrl: 'https://readdy.ai/api/search-image?query=Demon%20Slayer%20Infinity%20Castle%20arc%20anime%20key%20visual%2C%20intense%20action%20scene%2C%20Japanese%20traditional%20elements%2C%20dramatic%20fire%20and%20water%20effects%2C%20deep%20dark%20background%20with%20warm%20highlights%2C%20epic%20cinematic%20anime%20style&width=600&height=800&seq=trending-anime-03&orientation=portrait',
    tags: ['热血', '战斗', '剧场级'],
  },
  {
    id: 4,
    title: '迷宫饭 第二季',
    titleJa: 'ダンジョン飯 第2期',
    category: 'gaoxiao',
    region: 'riben',
    year: '2025',
    rating: 9.5,
    episode: '全12话',
    description: '莱欧斯小队在迷宫中继续他们的美食冒险，用各种魔物制作出令人意想不到的美味料理。',
    coverUrl: 'https://readdy.ai/api/search-image?query=Delicious%20in%20Dungeon%20anime%20season%202%20art%2C%20cooking%20in%20fantasy%20dungeon%2C%20colorful%20food%20and%20monsters%2C%20warm%20cozy%20atmosphere%2C%20fun%20character%20expressions%2C%20detailed%20culinary%20anime%20illustration&width=600&height=800&seq=trending-anime-04&orientation=portrait',
    tags: ['搞笑', '美食', '奇幻'],
  },
  {
    id: 5,
    title: '我推的孩子 第三季',
    titleJa: '【推しの子】 第3期',
    category: 'xuanyi',
    region: 'riben',
    year: '2026',
    rating: 9.6,
    episode: '更新至第6话',
    description: '星野爱的秘密逐渐揭开，演艺圈的黑暗面与兄妹二人的命运纠葛愈发扣人心弦。',
    coverUrl: 'https://readdy.ai/api/search-image?query=Oshi%20no%20Ko%20season%203%20anime%20visual%2C%20entertainment%20industry%20setting%2C%20idol%20theme%20with%20dramatic%20lighting%2C%20sparkling%20stage%20atmosphere%2C%20emotional%20character%20portrait%2C%20stylish%20modern%20anime%20art&width=600&height=800&seq=trending-anime-05&orientation=portrait',
    tags: ['悬疑', '偶像', '催泪'],
  },
];

export const latestUpdates = [
  {
    id: 6,
    title: '蓝色监狱 第二季',
    titleJa: 'ブルーロック 第2期',
    category: 'rexue',
    region: 'riben',
    year: '2025',
    rating: 9.3,
    episode: '更新至第10话',
    description: '蓝色监狱计划进入白热化阶段，洁世一与伙伴们为了成为世界第一前锋而全力拼搏。',
    coverUrl: 'https://readdy.ai/api/search-image?query=Blue%20Lock%20season%202%20anime%20visual%2C%20intense%20soccer%20action%20scene%2C%20dynamic%20sports%20movement%2C%20cool%20blue%20tone%20accents%2C%20dramatic%20sports%20anime%20illustration%20with%20energy%20effects&width=600&height=800&seq=latest-anime-01&orientation=portrait',
    tags: ['运动', '热血', '竞技'],
  },
  {
    id: 7,
    title: '我心里危险的东西 第三季',
    titleJa: '僕の心のヤバイやつ 第3期',
    category: 'lianai',
    region: 'riben',
    year: '2026',
    rating: 9.4,
    episode: '更新至第4话',
    description: '市川和山田的关系更进一步，青春期的甜蜜与烦恼交织在一起，让人心跳加速的校园恋爱。',
    coverUrl: 'https://readdy.ai/api/search-image?query=The%20Dangers%20in%20My%20Heart%20anime%20season%203%2C%20school%20romance%20scene%2C%20warm%20spring%20lighting%2C%20cherry%20blossom%20petals%2C%20sweet%20youthful%20atmosphere%2C%20soft%20pastel%20tone%20anime%20illustration&width=600&height=800&seq=latest-anime-02&orientation=portrait',
    tags: ['恋爱', '校园', '治愈'],
  },
  {
    id: 8,
    title: '怪兽8号 第二季',
    titleJa: '怪獣8号 第2期',
    category: 'zhanji',
    region: 'riben',
    year: '2026',
    rating: 9.2,
    episode: '更新至第7话',
    description: '日比野卡夫卡以怪兽之身守护人类的战斗继续，新的威胁与强敌不断出现。',
    coverUrl: 'https://readdy.ai/api/search-image?query=Kaiju%20No%208%20season%202%20anime%20art%2C%20giant%20monster%20battle%20scene%2C%20military%20sci-fi%20setting%2C%20dramatic%20action%20with%20explosion%20effects%2C%20dark%20urban%20background%2C%20epic%20anime%20cinematic%20style&width=600&height=800&seq=latest-anime-03&orientation=portrait',
    tags: ['战斗', '科幻', '热血'],
  },
  {
    id: 9,
    title: '药屋少女的呢喃 第二季',
    titleJa: '薬屋のひとりごと 第2期',
    category: 'richang',
    region: 'riben',
    year: '2026',
    rating: 9.5,
    episode: '更新至第9话',
    description: '猫猫在皇宫中运用药学知识解决各种谜题，与壬氏的微妙关系也让人欲罢不能。',
    coverUrl: 'https://readdy.ai/api/search-image?query=The%20Apothecary%20Diaries%20season%202%20anime%2C%20ancient%20Chinese%20palace%20setting%2C%20herbal%20medicine%20theme%2C%20elegant%20traditional%20clothing%2C%20warm%20lantern%20lighting%2C%20beautiful%20detailed%20anime%20illustration&width=600&height=800&seq=latest-anime-04&orientation=portrait',
    tags: ['日常', '推理', '古风'],
  },
  {
    id: 10,
    title: '我独自升级 第二季',
    titleJa: '俺だけレベルアップな件 第2期',
    category: 'zhanji',
    region: 'riben',
    year: '2026',
    rating: 9.3,
    episode: '更新至第11话',
    description: '程肖宇的实力持续飙升，面对S级猎人和更强大的地下城，他的战斗才刚刚开始。',
    coverUrl: 'https://readdy.ai/api/search-image?query=Solo%20Leveling%20season%202%20anime%20visual%2C%20dark%20fantasy%20hunter%20theme%2C%20shadow%20army%20with%20purple%20glow%2C%20powerful%20protagonist%20pose%2C%20dramatic%20dark%20atmosphere%2C%20cool%20action%20anime%20style&width=600&height=800&seq=latest-anime-05&orientation=portrait',
    tags: ['战斗', '奇幻', '爽番'],
  },
  {
    id: 11,
    title: '间谍过家家 第三季',
    titleJa: 'SPY×FAMILY 第3期',
    category: 'gaoxiao',
    region: 'riben',
    year: '2026',
    rating: 9.6,
    episode: '更新至第2话',
    description: '福杰一家的搞笑日常继续，阿尼亚的校园生活与新任务交织，温馨又有趣。',
    coverUrl: 'https://readdy.ai/api/search-image?query=Spy%20x%20Family%20season%203%20anime%20art%2C%20family%20comedy%20scene%2C%20stylish%20spy%20themed%20clothing%2C%20warm%20home%20atmosphere%2C%20fun%20character%20expressions%2C%20bright%20colorful%20anime%20illustration&width=600&height=800&seq=latest-anime-06&orientation=portrait',
    tags: ['搞笑', '日常', '温馨'],
  },
  {
    id: 12,
    title: '死神 千年血战篇 第三季',
    titleJa: 'BLEACH 千年血戦篇 第3クール',
    category: 'zhanji',
    region: 'riben',
    year: '2025',
    rating: 9.4,
    episode: '全13话',
    description: '一护与护廷十三队迎战无形帝国，卍解与星十字骑士团的终极对决震撼上演。',
    coverUrl: 'https://readdy.ai/api/search-image?query=Bleach%20Thousand%20Year%20Blood%20War%20anime%20visual%2C%20soul%20reaper%20action%20scene%2C%20dynamic%20sword%20combat%2C%20dramatic%20dark%20and%20light%20contrast%2C%20epic%20shonen%20anime%20style%20with%20energy%20auras&width=600&height=800&seq=latest-anime-07&orientation=portrait',
    tags: ['战斗', '经典', '热血'],
  },
  {
    id: 13,
    title: '关于邻家天使大人把我变成废人这档事 第二季',
    titleJa: 'お隣の天使様にいつの間にか駄目人間にされていた件 第2期',
    category: 'lianai',
    region: 'riben',
    year: '2026',
    rating: 9.1,
    episode: '更新至第3话',
    description: '周与真昼的甜蜜同居生活继续，天使般的邻家女孩让每一天都充满温暖。',
    coverUrl: 'https://readdy.ai/api/search-image?query=The%20Angel%20Next%20Door%20anime%20season%202%2C%20sweet%20school%20romance%20scene%2C%20warm%20golden%20hour%20lighting%2C%20cozy%20home%20atmosphere%2C%20gentle%20character%20expressions%2C%20soft%20romantic%20anime%20illustration&width=600&height=800&seq=latest-anime-08&orientation=portrait',
    tags: ['恋爱', '日常', '治愈'],
  },
];

export const featuredSpecials = [
  {
    id: 14,
    title: '进击的巨人 完结篇',
    description: '艾伦·耶格尔的最终选择，墙内外的命运在此交汇。完整回顾这部改变了动漫史的作品。',
    coverUrl: 'https://readdy.ai/api/search-image?query=Attack%20on%20Titan%20final%20season%20anime%20visual%2C%20epic%20scale%20battle%20scene%2C%20dramatic%20sky%20with%20titans%2C%20cinematic%20composition%2C%20dark%20atmosphere%20with%20warm%20sunset%20light%2C%20grand%20anime%20illustration&width=800&height=400&seq=featured-special-01&orientation=landscape',
  },
  {
    id: 15,
    title: '紫罗兰永恒花园',
    description: '自动手记人偶薇尔莉特追寻"爱"的含义，每一封信都承载着无法言说的情感。',
    coverUrl: 'https://readdy.ai/api/search-image?query=Violet%20Evergarden%20anime%20visual%2C%20beautiful%20European%20setting%2C%20elegant%20letter%20writing%20theme%2C%20soft%20golden%20lighting%20through%20windows%2C%20emotional%20atmosphere%2C%20stunning%20detailed%20anime%20illustration&width=800&height=400&seq=featured-special-02&orientation=landscape',
  },
  {
    id: 16,
    title: 'CLANNAD ～AFTER STORY～',
    description: '冈崎朋也与古河渚的人生故事，关于家庭、成长与爱的终极致敬。准备好纸巾再看。',
    coverUrl: 'https://readdy.ai/api/search-image?query=Clannad%20After%20Story%20anime%20visual%2C%20cherry%20blossom%20slope%20scene%2C%20warm%20spring%20sunlight%2C%20emotional%20family%20theme%2C%20nostalgic%20atmosphere%2C%20gentle%20beautiful%20anime%20illustration&width=800&height=400&seq=featured-special-03&orientation=landscape',
  },
  {
    id: 18,
    title: '钢之炼金术师 FULLMETAL ALCHEMIST',
    description: '爱德华与阿尔冯斯兄弟的炼金术之旅，等价交换法则下的人性拷问，不朽的经典神作。',
    coverUrl: 'https://readdy.ai/api/search-image?query=Fullmetal%20Alchemist%20Brotherhood%20anime%20visual%2C%20alchemy%20circle%20theme%2C%20steampunk%20military%20setting%2C%20two%20brothers%20in%20dramatic%20pose%2C%20warm%20sepia%20toned%20atmosphere%2C%20classic%20anime%20illustration&width=800&height=400&seq=featured-special-04&orientation=landscape',
  },
];